import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { SizableText, Spinner, YStack } from 'tamagui'

/**
 * Public landing page for DocuSign's embedded sender view.
 *
 * When an agent finishes (or cancels) the embedded send flow, DocuSign redirects
 * the iframe to this page with `?envelopeId=...&event=...`. It MUST be reachable
 * without auth: DocuSign loads it inside the iframe where the Clerk session isn't
 * available, so pointing the returnUrl at the auth-gated app root just renders the
 * sign-in screen. Here we notify the parent window (IframeModal) so it can close
 * the modal and refresh the form status — the actual status flip comes from the
 * DocuSign Connect webhook.
 */
const DocusignSenderReturn = () => {
    const [searchParams] = useSearchParams()
    const event = searchParams.get('event')

    useEffect(() => {
        window.parent?.postMessage(
            { source: 'docusign-sender-return', event },
            window.location.origin,
        )
    }, [event])

    return (
        <YStack
            flex={1}
            minHeight="100vh"
            alignItems="center"
            justifyContent="center"
            gap="$3"
        >
            <Spinner size="large" />
            <SizableText color="$gray11">Returning to Buyerflo…</SizableText>
        </YStack>
    )
}

export default DocusignSenderReturn
